import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';

const BulkImportStudents = () => {
  const navigate = useNavigate();
  const [file, setFile] = useState(null);

  const handleFileUpload = (e) => {
    const uploadedFile = e.target.files[0];
    setFile(uploadedFile);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!file) {
      alert('Please select a file to upload');
      return;
    }
    
    // Handle bulk import logic here
    console.log('File to upload:', file);
    alert('Bulk import functionality will be implemented here');
  };

  const downloadTemplate = () => {
    // Create a sample CSV template
    const csvContent = `Full Name,Email,Password,Student ID,Contact Number,Date of Birth,Gender,Address,Degree Programme,Group,Current Year,Current Semester,Enrollment Date,Status
John Doe,john.doe@example.com,password123,STU001,+1234567890,1995-01-15,Male,"123 Main St, City",Computer Science,CS-Y1-G1,1,1,2025-01-01,Active
Jane Smith,jane.smith@example.com,password456,STU002,+0987654321,1994-05-22,Female,"456 Oak Ave, Town",Software Engineering,SE-Y1-G1,1,1,2025-01-01,Active`;
    
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'students_import_template.csv';
    a.click();
    window.URL.revokeObjectURL(url);
  };

  return (
    <div style={{width: '100%', height: '100%', position: 'relative', background: 'white'}}>
      <Sidebar />
      
      <div style={{marginLeft: 290, width: 'calc(100% - 290px)', minHeight: '100vh'}}>
        <Header />
        
        <form onSubmit={handleSubmit}>
          <div style={{margin: '20px 40px', position: 'relative'}}>
            <div style={{background: '#F04915', borderTopLeftRadius: 15, borderTopRightRadius: 15, padding: '20px', color: 'white'}}>
              <h2 style={{fontSize: 24, fontFamily: 'Outfit', fontWeight: '700'}}>Bulk Import Students</h2>
            </div>

            <div style={{background: '#FFFBF5', padding: '40px'}}>
              {/* Instructions */}
              <div style={{marginBottom: '30px'}}>
                <h3 style={{fontSize: 20, fontFamily: 'Outfit', fontWeight: '600', color: '#333', marginBottom: '15px'}}>
                  Instructions:
                </h3>
                <ul style={{fontSize: 16, fontFamily: 'Outfit', color: '#666', lineHeight: '1.6'}}>
                  <li>Download the CSV template below</li>
                  <li>Fill in the student data following the template format</li>
                  <li>Upload the completed CSV file</li>
                  <li>Review and confirm the import</li>
                </ul>
              </div>

              {/* Download Template Button */}
              <div style={{marginBottom: '30px'}}>
                <button
                  type="button"
                  onClick={downloadTemplate}
                  style={{
                    background: '#28A745',
                    border: 'none',
                    borderRadius: 8,
                    color: 'white',
                    padding: '12px 24px',
                    fontSize: 16,
                    fontFamily: 'Outfit',
                    fontWeight: '500',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseOver={(e) => {
                    e.target.style.background = '#218838';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.background = '#28A745';
                  }}
                >
                  📥 Download CSV Template
                </button>
              </div>

              {/* File Upload */}
              <div style={{marginBottom: '30px'}}>
                <label style={{display: 'block', marginBottom: '8px', color: 'black', fontSize: 20, fontFamily: 'Outfit', fontWeight: '500'}}>
                  Upload CSV File <span style={{color: '#F04915'}}>*</span>
                </label>
                <div style={{
                  width: '100%', 
                  height: 150, 
                  border: '2px dashed #77838F', 
                  borderRadius: 12, 
                  display: 'flex', 
                  flexDirection: 'column',
                  alignItems: 'center', 
                  justifyContent: 'center', 
                  position: 'relative',
                  backgroundColor: file ? '#f8f9fa' : 'white'
                }}>
                  <input
                    type="file"
                    accept=".csv,.xlsx,.xls"
                    onChange={handleFileUpload}
                    style={{opacity: 0, position: 'absolute', width: '100%', height: '100%', cursor: 'pointer'}}
                  />
                  {file ? (
                    <div style={{textAlign: 'center'}}>
                      <div style={{fontSize: '48px', marginBottom: '10px'}}>📄</div>
                      <div style={{color: '#333', fontSize: 18, fontFamily: 'Outfit', fontWeight: '500'}}>
                        {file.name}
                      </div>
                      <div style={{color: '#666', fontSize: 14, fontFamily: 'Outfit'}}>
                        {(file.size / 1024).toFixed(2)} KB
                      </div>
                    </div>
                  ) : (
                    <div style={{textAlign: 'center'}}>
                      <div style={{fontSize: '48px', marginBottom: '10px'}}>📁</div>
                      <div style={{color: '#77838F', fontSize: 18, fontFamily: 'Outfit', fontWeight: '500'}}>
                        Click to upload CSV file
                      </div>
                      <div style={{color: '#77838F', fontSize: 14, fontFamily: 'Outfit', marginTop: '5px'}}>
                        Supported formats: CSV, XLS, XLSX
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* File Info */}
              {file && (
                <div style={{
                  background: '#e7f3ff', 
                  border: '1px solid #b3d7ff', 
                  borderRadius: 8, 
                  padding: '15px',
                  marginBottom: '20px'
                }}>
                  <h4 style={{fontSize: 16, fontFamily: 'Outfit', fontWeight: '600', color: '#0066cc', margin: '0 0 10px 0'}}>
                    File Ready for Import
                  </h4>
                  <p style={{fontSize: 14, fontFamily: 'Outfit', color: '#666', margin: 0}}>
                    Click Submit to process the uploaded file. Please review the data carefully before proceeding.
                  </p>
                </div>
              )}
            </div>
          </div>

          {/* Action Buttons */}
          <div style={{margin: '40px', display: 'flex', justifyContent: 'space-between'}}>
            <Link to="/add-student">
              <button 
                type="button" 
                style={{
                  width: 269, 
                  padding: '11px 20px', 
                  background: '#6C757D', 
                  border: 'none', 
                  borderRadius: 8, 
                  color: 'white', 
                  fontSize: 16, 
                  fontFamily: 'Outfit', 
                  fontWeight: '500', 
                  cursor: 'pointer',
                  transition: 'all 0.3s ease'
                }}
                onMouseOver={(e) => {
                  e.target.style.background = '#5A6268';
                }}
                onMouseOut={(e) => {
                  e.target.style.background = '#6C757D';
                }}
              >
                Back
              </button>
            </Link>
            <button 
              type="submit" 
              style={{
                width: 269, 
                padding: '11px 20px', 
                background: file ? '#F04915' : '#cccccc', 
                border: 'none', 
                borderRadius: 8, 
                color: 'white', 
                fontSize: 16, 
                fontFamily: 'Outfit', 
                fontWeight: '500', 
                cursor: file ? 'pointer' : 'not-allowed',
                transition: 'all 0.3s ease'
              }}
              disabled={!file}
              onMouseOver={(e) => {
                if (file) {
                  e.target.style.background = '#D63A0F';
                }
              }}
              onMouseOut={(e) => {
                if (file) {
                  e.target.style.background = '#F04915';
                }
              }}
            >
              Import Students
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default BulkImportStudents;
